import { makeStyles } from '@material-ui/core'
import themesConfig from 'app/fuse-configs/themesConfig'
import { useBreakpoints } from 'commons/useBreakpoints'

export default makeStyles((theme) => ({
  dialogWrap: {
    '& .MuiPaper-root': {
      padding: '24px 0',
      maxWidth: 482,
      [useBreakpoints(theme).lessThan.sm]: {
        padding: 10,
      },
      borderRadius: 16,
    },
  },

  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    padding: 0,
    color: themesConfig.default.colors.primary,
  },

  dialogTitle: {
    color: themesConfig.default.colors.primary,
    lineHeight: '24px',
    fontSize: 18,
    padding: '0 24px',
    fontWeight: 700,
    marginBottom: 8,
  },

  dialogContent: {
    color: themesConfig.default.colors['neutrals-600'],
    padding: '0 24px',
    fontSize: 14,
    lineHeight: '20px',
  },

  divider: {
    backgroundColor: themesConfig.default.colors[' primary-350'],
    margin: '14px 24px 40px 24px',
  },

  radioButton: {
    padding: 10,
    '& .MuiSvgIcon-root': {
      fill: themesConfig.default.colors['primary-500'],
    },
  },

  radioLabel: {
    color: themesConfig.default.colors.primary,
  },
  checkbox: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '& .MuiSvgIcon-root': {
      fill: themesConfig.default.colors.primary,
    },
  },

  checkboxLabel: {
    color: themesConfig.default.colors['neutrals-800'],
  },

  dialogActions: {
    padding: '0 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 8,
    [useBreakpoints(theme).lessThan.sm]: {
      flexWrap: 'wrap',
    },
  },
}))
